import { Phone, FileText } from "lucide-react";
import { Link } from "react-router-dom";
import { PHONE_HREF } from "./EmergencyBanner";

export const MobileCallButton = () => (
  <div className="fixed bottom-0 w-full bg-background/95 glass border-t border-border p-3 lg:hidden z-50 flex gap-2">
    <Link
      to="/contact"
      className="flex-1 flex items-center justify-center bg-primary text-primary-foreground font-bold py-3.5 rounded-lg active:scale-[0.97] transition-transform text-sm tracking-wide"
    >
      <FileText className="w-4 h-4 mr-2" />
      Free Quote
    </Link>
    <a
      href={PHONE_HREF}
      className="flex-1 flex items-center justify-center gradient-accent text-accent-foreground font-bold py-3.5 rounded-lg active:scale-[0.97] transition-transform shadow-glow text-sm tracking-wide"
    >
      <Phone className="w-5 h-5 mr-2" />
      Call Now
    </a>
  </div>
);
